import { Autocomplete, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { GridContainer, Grid } from 'src/shared/grid';
import { chipIcon } from '../FuelTypes/FuelTypesBrowse';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ONEDAY, ValidCharacters, isValidDate, validateCharacters } from 'src/store/common';
import moment from 'moment-timezone';
import { useStoreContext } from 'src/store/context';
import { getAuditTrail, getSubSamples } from 'src/apis/getFuelSampleCalls';
import LoadingSpinner from 'src/shared/loading/loading';

type AuditProps = {
    setOpen: any,
    open: boolean,
    sample: any
}


export const AuditLog: React.FC<AuditProps> = ({ setOpen, open, sample }) => {
    const [startDate, setStartDate] = useState<any>(moment(moment().valueOf()-(30*ONEDAY)).utc().toDate());
    const [endDate, setEndDate] = useState<any>(moment().utc().toDate());
    const [errorStartDate, setErrorStartDate] = useState<string|null>(null)
    const [errorEndDate, setErrorEndDate] = useState<string|null>(null);
    const [state] = useStoreContext();
    const [auditItems, setAuditItems] =useState<any[]>([]);
    const [callAuditComplete, setCallAuditComplete] = useState(false);
    const [message, setMessage ] = useState('');
    const [ activityType, setActivityType] = useState<string>("All");
    const [ allActivityType] = useState(["All", "Add", "Update"]);
      /* this will handle end date changed*/
    const handleEndDate = (newValue: any) => {
        if (!isValidDate(newValue)) {
            setErrorEndDate('Invalid Date');
            return;
        }
        setEndDate(moment(newValue).utc().toDate());
        if ((moment(newValue) >= moment(startDate))) {
            if (errorStartDate === 'Invalid Date' || (moment() <= moment(startDate)) || (moment() <= moment(endDate)) || newValue === 'Invalid Date') {
                return
            }
            else {
                setErrorEndDate(null)
                setErrorStartDate(null)
            }
        }
        else if (moment(newValue) < moment(startDate)) {
            setErrorEndDate('End Date is before Start Date');
        }
        else {
            setErrorEndDate('Invalid Date');
        }
    }
    /* this will handle start date*/
    const handleStartDate = (newValue: any)=>{
        if( !isValidDate(newValue) ){
          setErrorStartDate('Invalid Date');
          return;
        }
        setStartDate(moment(newValue).utc().toDate());
        if((moment(newValue) <= moment(endDate))){
          if(errorEndDate=== 'Invalid Date' || (moment()<=moment(startDate)) || moment()<=moment(endDate) || newValue=== 'Invalid Date'){
            return
          }
          
          else{
            setErrorEndDate(null)
            setErrorStartDate(null)
          }
        }
        else if(moment(newValue) > moment(endDate)) {
          setErrorStartDate('Start Date is after End Date');
        }
        else{
          setErrorStartDate('Invalid Date');
        }
      }

    const mapAuditFields = (auditField:string)=>{
        switch (auditField) {
            case 'wet_weight':
              return( <span style={{fontWeight: 'bold'}}>{`wet weight `}</span>)
            case 'sub_category':
              return(<span style={{fontWeight: 'bold'}}>{`sub category `}</span>)
            case 'tar_weight':
              return(<span style={{fontWeight: 'bold'}}>{`tare weight `}</span>)
            case 'site_id':
              return(<span style={{fontWeight: 'bold'}}>{`site id `}</span>)
            case 'sample_average_value':
              return(<span style={{fontWeight: 'bold'}}>{`value `}</span>)
            case 'status':
                return(<span style={{fontWeight: 'bold'}}>{`status `}</span>)
            case 'sample':
              return(<span style={{fontWeight: 'bold'}}>{`sample `}</span>)
            case 'dry_weight':
              return(<span style={{fontWeight: 'bold'}}>{`dry weight `}</span>)
            case 'fuel_id':
              return(<span style={{fontWeight: 'bold'}}>{`fuel type `}</span>)
            case 'method_type':
              return(<span style={{fontWeight: 'bold'}}>{`method `}</span>)
            default:
              return (null)
          }
    };

    const cleanFuelIDResponse = (fuelString: string) =>{
        fuelString = fuelString.substring(fuelString.indexOf("-") + 1);
        return fuelString
    }
    const handleColorDescription = (description: string, person: string,  auditType:string, auditField:string) =>{
        const indexOfFirstBracket = description.indexOf('[')+1;
        const indexOfFirstEndBracket =description.indexOf(']')+1;
        const toGetSecondSubString = description.slice(indexOfFirstEndBracket);
        const indexOfSecondBracket = (toGetSecondSubString).indexOf('[')+1;
        const indexOfSecondEndBracket =(toGetSecondSubString).indexOf(']');
        if(auditType.includes('Add')){
            const newValue = toGetSecondSubString.slice(indexOfSecondBracket, indexOfSecondEndBracket);
            let newValueString =newValue;
            if(auditField.includes('fuel_id')){
                newValueString = cleanFuelIDResponse(newValue);

            }
           return(
                <>
                    <span style={{fontWeight:'bold'}}>{person}</span>
                    <span>{` entered the `}</span>
                    {mapAuditFields(auditField)}
                    {moment(newValue).isValid() ? (
                        <span style={{fontWeight:'bold', color: '#006546'}}>
                            {` ${moment.tz(newValue, state.userTimeZone.id[0]).format('MM/DD/YY')} ${moment.tz(newValue, state.userTimeZone.id[0]).format('HH:ss')} ${state.userTimeZone.code}`}
                        </span>
                    ):(
                        <span style={{fontWeight:'bold', color: '#006546'}}>{` ${newValueString}`}</span>
                    )}
                </>
            )
        }
        else{
            const prevValue = description.slice(indexOfFirstBracket, indexOfFirstEndBracket-1)
            const newValue = toGetSecondSubString.slice(indexOfSecondBracket, indexOfSecondEndBracket);

            let newValueString =newValue;
            let prevValueString=prevValue
            if(auditField.includes('fuel_id')){
                newValueString = cleanFuelIDResponse(newValue);
                prevValueString = cleanFuelIDResponse(prevValue)
            }
            return(
                <>
                    {moment(newValue).isValid() && moment(prevValue).isValid() ? (
                    <>
                        <span style={{fontWeight:'bold'}}>{person}</span>
                        <span>{` updated the `}</span>
                        {mapAuditFields(auditField)}
                        <span style={{fontWeight:'bold', color: '#006546'}}>
                            {` ${moment.tz(prevValue, state.userTimeZone.id[0]).format('MM/DD/YY')} ${moment.tz(prevValue, state.userTimeZone.id[0]).format('HH:ss')} ${state.userTimeZone.code}`}
                        </span>
                        <span>{`to`}</span>
                        <span style={{fontWeight:'bold', color: '#006546'}}>
                            {` ${moment.tz(newValue, state.userTimeZone.id[0]).format('MM/DD/YY')} ${moment.tz(newValue, state.userTimeZone.id[0]).format('HH:ss')} ${state.userTimeZone.code}`}

                        </span>
                    </>                            
                    ):(
                        <>
                            <span style={{fontWeight:'bold'}}>{person}</span>
                            <span>{` updated the `}</span>
                            {mapAuditFields(auditField)}
                            <span>{`to`}</span>
                            <span style={{fontWeight:'bold', color: '#006546'}}>{` ${newValueString} `}</span>
                            <span>{`from`}</span>
                            <span style={{fontWeight:'bold', color: '#006546'}}>{` ${prevValueString} `}</span>

                        </>
                    )
                }
                </>

            )
        
        }
    }


    /**Make a call to populate the table with the bulk data job files */
  const auditResponse = useCallback(() => {
    setCallAuditComplete(false);
    
    (async () => {
      try {
        const subSamples: any = await getSubSamples('', sample.fuel_sample_id);
        const sampleObj = {fuel_sub_sample_id: sample.fuel_sample_id, type: 'fuel.fuel_sample'}
        const subSampleAddType = subSamples.map((sub:any)=>{
            return{
                ...sub,
                type: 'fuel.fuel_sub_sample'
            }
        })
        const combinedSubAndSample = [...subSampleAddType, sampleObj];

        const allIds = combinedSubAndSample.map(s=>s.fuel_sub_sample_id).join(',');

        const req = {
            returnAll: false,
            auditTrailItemId: null,
            entityType: null,
            entityId: allIds,
            auditType: activityType,
            auditField: 'All',
            activityStartDate: startDate,
            activityEndDate: endDate,
        };
        
        const auditPromise: any = await getAuditTrail(req);

        let auditFiltered = auditPromise?.filter(aItem=>
            combinedSubAndSample.some(beforeItem=>Number(beforeItem.fuel_sub_sample_id)===Number(aItem.entityId) && beforeItem.type===aItem.entityType)    
        )

        setAuditItems(auditFiltered?.sort((a: any, b: any) => new Date(b.modifiedTime).getTime() - new Date(a.modifiedTime).getTime()));
        setCallAuditComplete(true);
        setMessage('')
        if(auditPromise?.length<1){
            setMessage('No Audit Data Available for the Selected Activity Date Range and Type')
        }


      } catch (error:any) {
        console.log('error', error)
        if(error?.message.includes('audit item not found')){
            setMessage('No Audit History found for this Sample')
        }
        else{
            setMessage('Data could not be retrieved. Please try again.')
        }
        setCallAuditComplete(true)

    }
    })();
  }, [startDate, endDate, sample, activityType]); 

  useEffect(() => {
    auditResponse()
  },[ auditResponse]);

    const auditTitle = (type: string,subCat: string| null, method: string| null)=>{
        if(!method && !subCat){
            return ` ${type}`;
        }
        else if(!method && subCat){
            return ` ${type} - ${subCat}`
        }
        else if(method && !subCat){
            return ` ${type} - ${method}`
        }
        else{
            return ` ${type} - ${subCat} - ${method}`
        }
    }

    const iconType = (type:string)=>{
        if(type.toLowerCase().includes('add')){
            return(<LibraryAddOutlinedIcon/>)
        }
        else if(type.toLowerCase().includes('update')){
            return(<EditNoteOutlinedIcon/>)
        }
        else{
            return null;
        }
    }

    return (
        <GridContainer className="removePadding">
            <Grid row gap="md" className='page-heading'>
                <Grid
                    desktop={{ col: 12 }}
                    className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
                    <span className="font-sans-lg text-bold">{chipIcon(sample.fuel.category, '#575757')}{auditTitle(sample.fuel.fuel_type, sample.sub_category, sample.method)}</span>
                </Grid>
            </Grid>
            <hr></hr>
            <Grid row gap="md" style={{ marginLeft: '3rem', marginRight: '2rem', marginBottom: '1rem'}}>
                <div style={{ width: '25%' }}>
                    <label className="font-sans-md text-bold" htmlFor='activityStartDate'>Activity Start Date</label>
                </div>
                <div style={{ width: '25%' }}>
                    <label className="font-sans-md text-bold" htmlFor='activityEndDate'>Activity End Date</label>
                </div>
                <div style={{ width: '25%' }}>
                    <label className="font-sans-md text-bold" htmlFor='activityType'>Activity Type</label>
                </div>
            </Grid>
            <Grid row gap="md" style={{ marginLeft: '3rem', marginRight: '2rem', marginBottom: '1rem'}}>
                <div style={{ width: '25%' }}>
                    <DatePicker
                        disableFuture
                        value={startDate}
                        slotProps={{
                            textField: {
                                error: errorStartDate ? true : false,
                                helperText: errorStartDate,
                                id: 'activityStartDate',
                            },

                        }}
                        onError={(reason) => {
                            if (reason === 'disableFuture') {
                                setErrorStartDate('Start Date is in the Future');
                            }
                            else if (reason === 'invalidDate') {
                                setErrorStartDate('Invalid Date');
                            }
                            else if (reason === null && moment(startDate) <= moment(endDate)) {
                                setErrorStartDate(null);
                                setErrorEndDate(null);
                            }
                            else if (moment(startDate) > moment(endDate)) {
                                setErrorStartDate('Start Date is after End Date');
                            }
                            else {
                                setErrorStartDate('An Error on Start Date')
                            }
                        }}
                        onChange={(newValue) => { handleStartDate(newValue) }}
                    />
                </div>
                <div style={{ width: '25%' }}>
                    <DatePicker
                        value={endDate}
                        disableFuture
                        aria-labelledby='activityEndDate'

                        onError={(reason) => {
                            if (reason === 'disableFuture') {
                                setErrorEndDate('End Date is in the Future');
                            }
                            else if (reason === 'invalidDate') {
                                setErrorEndDate('Invalid Date');
                            }
                            else if (reason === null && moment(startDate) <= moment(endDate)) {
                                setErrorStartDate(null);
                                setErrorEndDate(null);
                            }
                            else if (moment(startDate) > moment(endDate)) {
                                setErrorEndDate('End Date is before End Date');
                            }
                            else {
                                setErrorStartDate('An Error on Start Date')
                            }
                        }}
                        slotProps={{
                            textField: {
                                error: errorEndDate ? true : false,
                                helperText: errorEndDate,
                                id: 'activityEndDate',

                            },
                        }}
                        onChange={(newValue) => handleEndDate(newValue)}
                    />
                </div>
                <div style={{ width: '25%' }}>
                    <Autocomplete
                        className="height-55"
                        value={activityType}
                        aria-labelledby='activityType'
                        id="activityType"
                        onChange={(event: any, newValue: any) => {
                            setActivityType(newValue)
                        }}
                        disableClearable
                        options={(allActivityType)}
                        renderInput={(params) => (
                            <TextField
                                onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen, ValidCharacters.Comma)}
                                data-testid={'activityType'}
                                {...params}
                                label=""
                                InputProps={{
                                    ...params.InputProps,
                                    type: 'search',
                                }}
                            />
                        )}
                    />
                </div>
            </Grid>

            <Grid row gap="md">
                
                <Grid
                    desktop={{ col: 12 }}
                    className="smooth-scrollbar"
                    style={{ marginLeft: '3rem', marginRight: '2rem', maxHeight: '25rem', marginBottom: '2rem'}}
                >
                    <TableContainer component={Paper} className='margin-top-2 first-table MuiPaper-root-special'>

                        {/* TABLE FOR FUELS*/}
                        <Table
                            sx={{ minWidth: 200, minHeight: 100 }}
                        >
                            <colgroup>
                                <col width="20%"/>
                                <col width="60%"/>
                                <col width="20%"/>
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell tabIndex={0} className="headerParent2" >TYPE</TableCell>
                                    <TableCell tabIndex={0} className="headerParent2" >ACTIVITY</TableCell>
                                    <TableCell tabIndex={0} className="headerParent2" >ACTIVITY DATE</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    callAuditComplete? (
                                        auditItems?.length > 0 && auditItems.map((row, index) => {
                                            return (
                                                <TableRow key={row.id}>
                                                    <TableCell tabIndex={0}>{iconType(row.auditType)} {row.auditType}</TableCell>
                                                    <TableCell tabIndex={0}>{handleColorDescription(row.description, row.modifiedBy, row.auditType, row.auditField)}</TableCell>
                                                    <TableCell tabIndex={0}>{moment(row.modifiedTime).format('MM/DD/YY')}</TableCell>
        
                                                </TableRow>
                                            )
                                        })
                                    ):
                                    (
                                        <div style={{height: '200px'}}>
                                        <LoadingSpinner/>
                                      </div>
                                    )
                                }
                                {callAuditComplete && auditItems?.length < 1 &&
                                    <TableRow>
                                        <TableCell colSpan={3}>
                                            {message}
                                        </TableCell>
                                    </TableRow>
                                }
                            </TableBody>

                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>


            <Grid row className='modalBottomDiv'>
                <Grid desktop={{ col: 12 }} className="modalCancelDiv">
                    <Button variant="outlined" style={{ backgroundColor: 'white' }} onClick={() => { setOpen(!open) }}>
                        Close
                    </Button>
                </Grid>

            </Grid>
        </GridContainer>
    )
}